import Hero from "components/Hero/Hero";
import "./LandingPage.css";
import FileUploader from "components/FileUploader/FileUploader";
import ProgressStages from "components/Stages/Stages";
import useLandingPage from "./useLandingPage";
import { Marketing } from "components/Marketing/Marketing";
import { ListenPage } from "components/listen/Listen";

export const LandingPage = () => {
  const { handlers, data } = useLandingPage();
  const { handleUpload } = handlers;
  const { progressStagesProps, error, isDone, projectID } = data;
  return (
    <div>
      <div className="landing-page-container shadow">
        <div className="landing-page-child-1">
          <Hero
            title="Master with ease..."
            subtitle="Unleash the Magic of AI – Transform Your Mixes into Masterpieces!"
          />
        </div>

        <div className="landing-page-child-2">
          {progressStagesProps.stage === -1 ? (
            <FileUploader onUpload={handleUpload} />
          ) : (
            <ProgressStages {...progressStagesProps} />
          )}
          {error && (
            <div
              style={{
                textAlign: "center",
                background: "red",
                color: "white",
                padding: 10,
              }}
            >
              {error}
            </div>
          )}
        </div>
      </div>
      {isDone ? <ListenPage projectID={projectID} trackName={progressStagesProps.fileName} /> : <Marketing />}
    </div>
  );
};
